
<form class="pl-2" [formGroup]="termosUSPersonForm">

  <div class="form-group">
    <p class="mb-3"><strong class="blue mr-2">Você é um Us Person?</strong></p>

    <div class="form-check form-check-inline">
      <input formControlName="decUSPerson" id="decUSPersonSim" class="form-check-input" type="radio" value="S"/>
      <label class="form-check-label" for="decUSPersonSim">SIM</label>
    </div>

    <div class="form-check form-check-inline">
      <input formControlName="decUSPerson" id="decUSPersonNao" class="form-check-input" type="radio" value="N"/>
      <label class="form-check-label" for="decUSPersonNao">NÃO</label>
    </div>

    <div class="input-group mt-4" style="max-width: 350px;">
      <input type="password" class="form-control" placeholder="Assinatura Eletrônica" formControlName="assinatura">
      <div class="input-group-append">
        <button class="btn btn-success" type="button" (click)="salvarUSPerson()" [disabled]="!termosUSPersonForm.valid || loadingUSPerson">
          Salvar
          @if (loadingUSPerson) {
            <i class="fas fa-spinner fa-spin"></i>
          }
        </button>
      </div>
    </div>
  </div>

</form>


<form class="pl-2 mt-5" [formGroup]="termosPPEForm">

  <div class="form-group">
    <p class="mb-3"><strong class="blue mr-2">Você é uma Pessoa Politicamente Exposta?</strong></p>

    <div class="form-check form-check-inline">
      <input formControlName="decPPE" id="decPPESim" class="form-check-input" type="radio" value="S"/>
      <label class="form-check-label" for="decPPESim">SIM</label>
    </div>

    <div class="form-check form-check-inline">
      <input formControlName="decPPE" id="decPPENao" class="form-check-input" type="radio" value="N"/>
      <label class="form-check-label" for="decPPENao">NÃO</label>
    </div>

    <div class="input-group mt-4" style="max-width: 350px;">
      <input type="password" class="form-control" placeholder="Assinatura Eletrônica" formControlName="assinatura">
      <div class="input-group-append">
        <button class="btn btn-success" type="button" (click)="salvarPPE()" [disabled]="!termosPPEForm.valid || loadingPPE">
          Salvar
          @if (loadingPPE) {
            <i class="fas fa-spinner fa-spin"></i>
          }
        </button>
      </div>
    </div>
  </div>

</form>

<form class="pl-2 mt-5" [formGroup]="nifForm">

  <div class="form-group">
    <p class="mb-3"><strong class="blue mr-2">Possui Residência Fiscal em outros países?</strong></p>

    <div class="form-check form-check-inline">
      <input formControlName="decOutraNacionalidade" id="decOutraNacionalidadeSim" class="form-check-input" type="radio" value="S" (click)="onChangeOutraNacionalidade('S')"/>
      <label class="form-check-label" for="decOutraNacionalidadeSim">SIM</label>
    </div>

    <div class="form-check form-check-inline">
      <input formControlName="decOutraNacionalidade" id="decOutraNacionalidadeNao" class="form-check-input" type="radio" value="N" (click)="onChangeOutraNacionalidade('N')"/>
      <label class="form-check-label" for="decOutraNacionalidadeNao">NÃO</label>
    </div>

  </div>

  @if (nifForm.get('decOutraNacionalidade').value == 'S') {
    <fieldset class="p-5" style="border: solid 1px #ccc;">
      <div class="row mx-0 mt-2">
        <div class="col-4">
          <input class="mb-2 form-control" type="text" placeholder="NIF" formControlName="numNIF">
        </div>
        <div class="col-4">
          <select class="select-text form-control" formControlName="dcrNacionalidade">
            <option selected disabled value="">Selecione a Nacionalidade</option>
            @for (item of nacionalidades; track item) {
              <option [value]="item.DCR_NACIONALIDADE" >{{item.DCR_NACIONALIDADE}}</option>
            }
          </select>
        </div>
        <div class="col-4">
          <button type="button" class="btn btn-success" (click)="incluirNIF()" [disabled]="!nifForm.valid">Incluir</button>
          @if (nifForm.get('assinatura').value.length < 8) {
            <span class="text-danger ml-3">Digite sua assinatura eletrônica</span>
          }
        </div>
      </div>
      @if (dados!=null) {
        <div class="row mx-0 mt-5">
          <div class="col-8">
            <ul id="nif-component">
              @for (item of dados.nacionalidades; track item) {
                <li style="display: flex; justify-content: space-evenly; align-items: center; background: #F5F5F5; padding: 12px 0 8px 0;">
                  <div style="color: #8B8B8B; width: 30%;">{{ item.NI }}</div>
                  <div style="color: #8B8B8B; width: 30%;">{{ item.DCR_NACIONALIDADE }}</div>
                  <div style="width: 30%;">
                    <a (click)="removerNIF(item.DCR_NACIONALIDADE)" style="font-size: 16px; margin: 0; cursor: pointer;" title="remover">
                      <i class="fas fa-times icone"></i>
                    </a>
                    @if (nifForm.get('assinatura').value.length < 8) {
                      <span class="text-danger ml-3">Digite sua assinatura eletrônica</span>
                    }
                  </div>
                </li>
              }
            </ul>
          </div>
        </div>
      }
      <div class="row mx-0 mt-5">
        <div class="col-4">
          <input type="password" class="form-control" placeholder="Assinatura Eletrônica" formControlName="assinatura">
        </div>
      </div>
    </fieldset>
  }

</form>